import axios from "axios";
import { config } from "../configs";
import { getSessionToken } from "./getToken";

const createPlace = async (placeData, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/places`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
        data: placeData,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgPlaces = async (orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/places`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export { createPlace, getOrgPlaces };
